/* eslint-disable no-await-in-loop */
import Dialog from "components/Dialog/Dialog";
import { useMap, addNewItem } from "context/mapContext";
import MunsAccordion from "components/MunsAccordion";
import { useEffect, useReducer, useState } from "react";
import { dialogReducer, dialogInitState } from "reducers/dialog";
import handleZoom from "utils/handleZoom";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useLoading, handleLoading } from "context/LoadingContext";
import performActionOnFeature from "utils/performActionOnFeature";
import checkApplyEditsErrors from "utils/checkApplyEditsErrors";
import { useEsriUrls } from "context/esriUrlsContext";

function NewJobZone() {
  const [map, dispatchMap] = useMap();
  const {
    polesList,
    view,
    graphicsLayer,
    selectionGeometry,
    sketchLayer,
    bufferLayer,
    jobZonesList,
    munQuery,
  } = map;

  const [, dispatchLoading] = useLoading();
  const [esriUrls] = useEsriUrls();

  const methods = useForm();

  const {
    register,
    formState: { errors },
    handleSubmit,
    getValues,
    reset,
  } = methods;

  const [munsList, setMunsList] = useState([]);
  const [selectedMun, setselectedMun] = useState(null);
  const [unselectMunDialogState, dispatchUnselectMunDialog] = useReducer(
    dialogReducer,
    dialogInitState
  );

  const [submitDialogState, dispatchSubmitDialog] = useReducer(
    dialogReducer,
    dialogInitState
  );

  const toggleUnselectMunDialog = (item) => {
    dispatchUnselectMunDialog({ type: "TOGGLE" });
    if (item) {
      setselectedMun(item);
    }
  };

  const handleUnselectMun = () => {
    const dataWithoutDeleted = polesList?.filter(
      (pole) => pole.Municipality !== selectedMun
    );
    dispatchMap({
      type: "INIT",
      payload: {
        polesList: dataWithoutDeleted,
        selectionGeometry: null,
      },
    });

    dispatchUnselectMunDialog({ type: "TOGGLE" });
    handleZoom(dataWithoutDeleted, view, graphicsLayer);
  };

  const handleBack = () => {
    dispatchMap({
      type: "INIT",
      payload: {
        polesSelectionComponentMode: "jobZoneList",
        polesList: [],
        selectionGeometry: null,
      },
    });
    graphicsLayer.removeAll();
    sketchLayer.removeAll();
    bufferLayer.removeAll();
  };

  const handleCancel = () => {
    dispatchMap({
      type: "INIT",
      payload: {
        polesList: [],
        selectionGeometry: null,
      },
    });
    graphicsLayer.removeAll();
    sketchLayer.removeAll();
    bufferLayer.removeAll();
  };

  const handleSubmitDialog = () => {
    dispatchSubmitDialog({ type: "TOGGLE" });
  };

  const handleCancelSubmitJobZone = () => {
    dispatchSubmitDialog({ type: "TOGGLE" });
  };

  const handleSubmitJobZone = async () => {
    handleLoading(dispatchLoading, true);
    try {
      const tempJobZoneData = {
        ...getValues(),
        Selected_Mun: munQuery,
        geometry: selectionGeometry,
      };

      const jobZoneNotificationMessages = {
        onSuccessMessage: "Zone Created Successfully",
        onErrorMessage: "Error Creating Zone",
      };

      const jobZonesUrl = `${process.env.REACT_APP_SERVICE_ENDPOINT}/${process.env.REACT_APP_YELLOW_DOOR_SERVICE}/FeatureServer/${esriUrls.Job_Zones}`;

      const jobZonesRes = await performActionOnFeature({
        url: jobZonesUrl,
        objs: tempJobZoneData,
        action: "add",
        notificationMessages: jobZoneNotificationMessages,
      });

      const createJZHasError = checkApplyEditsErrors(jobZonesRes);

      if (!createJZHasError) {
        addNewItem({
          dispatch: dispatchMap,
          newObj: tempJobZoneData,
          data: jobZonesList,
          targetName: "jobZonesList",
        });

        dispatchMap({
          type: "INIT",
          payload: {
            polesSelectionComponentMode: "jobZoneList",
            polesList: [],
            selectionGeometry: null,
          },
        });
        graphicsLayer.removeAll();
        sketchLayer.removeAll();
        bufferLayer.removeAll();
        dispatchSubmitDialog({ type: "TOGGLE" });
        reset();
      }
    } catch (error) {
      console.log(error);
    }
    handleLoading(dispatchLoading, false);
  };

  useEffect(() => {
    if (polesList?.length) {
      const allMuns = polesList?.map((unit) => unit.Municipality);
      const uniqueMunsList = Array.from(new Set(allMuns));
      setMunsList(uniqueMunsList);
    }
    if (!polesList?.length) {
      setMunsList([]);
    }
  }, [polesList]);

  return (
    <div
      className="meters"
      style={{
        position: "relative",
        // alignContent: munsList?.length ? "normal" : "center",
      }}
    >
      <div className="btn_group mb-3">
        <button
          type="button"
          className="btn btn--icon btn--outline--primary"
          onClick={handleBack}
          style={{ height: "50px" }}
        >
          <i className="fa-solid fa-arrow-left end" />
          Back
        </button>
      </div>
      {munsList?.length ? (
        munsList?.map((mun) => (
          <MunsAccordion
            toggleUnselectMunDialog={toggleUnselectMunDialog}
            item={mun}
            polesList={polesList}
            key={mun}
            selectionGeometry={selectionGeometry}
          />
        ))
      ) : (
        <div style={{ color: "grey" }}>
          <div
            className="text-center"
            style={{ marginBottom: "40px", fontSize: "20px" }}
          >
            Use Draw Tool to Display Results{" "}
          </div>
          <div
            style={{
              display: "flex",
              fontSize: "60px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <i
              className="fa-solid fa-bars"
              style={{ fontSize: "60px", marginInline: "20px" }}
            />
            /
            <i
              className="fa-solid fa-draw-polygon"
              style={{ fontSize: "60px", marginInline: "20px" }}
            />
          </div>
        </div>
      )}
      {polesList?.length ? (
        <div className="submit-div">
          <button
            type="button"
            className="btn btn--outline--primary"
            onClick={handleCancel}
            style={{
              borderRadius: "10px",
              paddingInline: "30px",
              fontSize: "14px",
              marginInlineEnd: "10px",
              width: "40%",
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn--primary"
            onClick={handleSubmitDialog}
            style={{ width: "60%" }}
          >
            Submit
          </button>
        </div>
      ) : null}
      <Dialog
        state={unselectMunDialogState}
        dispatch={dispatchUnselectMunDialog}
        footer={false}
        centered
        dialogClassName=""
        title=""
        closeButton
        className="transferTaskOrderDialog"
      >
        <div>
          <span>Are you sure you want to unselect this zone?</span>
          <div
            className="d-flex mt-3"
            style={{ justifyContent: "space-evenly" }}
          >
            <button
              type="button"
              className="btn btn--primary"
              style={{
                "--bg": "#c9252d",
              }}
              onClick={handleUnselectMun}
            >
              Yes
            </button>
            <button
              type="button"
              className="btn btn--primary"
              onClick={() => dispatchUnselectMunDialog({ type: "TOGGLE" })}
            >
              No
            </button>
          </div>
        </div>
      </Dialog>
      <Dialog
        state={submitDialogState}
        dispatch={dispatchSubmitDialog}
        footer={false}
        title=""
        closeButton
        centered
        className="transferTaskOrderDialog"
      >
        <form onSubmit={handleSubmit(handleSubmitJobZone)}>
          <Form.Group className="mb-3 input input-md" controlId="formTTOrder">
            <Form.Label style={{ textAlign: "start", color: "#8C98A9" }}>
              Job Zone Name
            </Form.Label>
            <Form.Control
              autoComplete="false"
              type="text"
              placeholder="Enter Job Zone Name"
              {...register("Zone_Name", {
                required: "Please Enter a Name",
              })}
            />
            {errors.Zone_Name && (
              <Form.Text className="text-danger">
                {errors.Zone_Name.message}
              </Form.Text>
            )}
          </Form.Group>
          <div
            className="d-flex mt-3"
            style={{ justifyContent: "space-evenly" }}
          >
            <button
              type="submit"
              className="btn btn--primary"
              // style={{ width: "100%", marginTop: "25px" }}
              // onClick={(e) => handleAddSpareUnits(e, dispatchSpare52WattDialog)}
            >
              Submit
            </button>
            <button
              type="button"
              className="btn btn--primary"
              style={{
                "--bg": "#c9252d",
              }}
              onClick={handleCancelSubmitJobZone}
            >
              Cancel
            </button>
          </div>
        </form>
        {/* <div>
          <span>Submit Job Zone?</span>
          <div
            className="d-flex mt-3"
            style={{ justifyContent: "space-evenly" }}
          >
            <button
              type="button"
              className="btn btn--primary"
              // onClick={handleSubmitIT}
            >
              Submit
            </button>
            <button
              type="button"
              className="btn btn--primary"
              style={{
                "--bg": "#c9252d",
              }}
              onClick={handleCancelSubmitIT}
            >
              Cancel
            </button>
          </div>
        </div> */}
      </Dialog>
    </div>
  );
}

export default NewJobZone;
